import { endpoints } from 'services/endpoints';
import request from 'services/request';
import { paramsToFormData } from 'utils/utils';

export default {
  postEMailTemplateList: (params: MailTemplateListReqDto): Promise<MailTempalteListResDto> =>
    request({
      url: endpoints.emailtemplate.list,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postEMailTemplateInfo: (params: MailTemplateSaveReqDto): Promise<MailTempalteInfoResDto> =>
    request({
      url: endpoints.emailtemplate.info,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postEMailTemplateAdd: (params: MailTemplateSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.emailtemplate.add,
      method: 'post',
      data: paramsToFormData(params),
    }),
   postEMailTemplateSave: (params: MailTemplateSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.emailtemplate.update,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postEMailTemplateDelete: (params: MailTemplateSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.emailtemplate.delete,
      method: 'post',
      data: paramsToFormData(params),
    }),        
};
